<div class="portfolio-assumptions-compare">
  <klt-section
    title="Property portfolio assumptions"
    type="button"
    buttonText="COMPARE"
    (buttonClick)="handleClick()"
  >
  </klt-section>
</div>
